import { roleModel } from '@ucr/role-model';

type TPermission = (typeof roleModel.permissions)[number];
export type TPermissionKey = TPermission['key'];
export type TRole = (typeof roleModel.roles)[number];
export type TRoleKey = TRole['key'];

export const isRoleKey = (key: unknown): key is TRoleKey => {
  return roleModel.roles.some((role) => role.key === key);
};
